import Veiculo from "./Veiculo";

export default class Manutencao {
  constructor(id, data, km, descricao, valor, observacao, responsavel) {
    this.id = id;
    this.data = data;
    this.km = km;
    this.descricao = descricao;
    this.valor = valor;
    this.observacao = observacao;
    this.responsavel = responsavel;
    this.entrada = new Veiculo(0, "", "", "", "", "", "");
  }

  update(manutencao) {
    this.id = manutencao.id;
    this.data = manutencao.data;
    this.km = manutencao.km;
    this.descricao = manutencao.descricao;
    this.valor = this.getCurrency(manutencao.valor);
    this.observacao = manutencao.observacao;
    this.responsavel = manutencao.responsavel;
    this.veiculo = manutencao.veiculo;
  }

  getCurrency(valor) {
    valor = parseFloat(valor).toFixed(2);
    var inteira = valor.substr(0, valor.length - 3);
    var ajuste = inteira.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var decimal = valor.substr(valor.length - 3, valor.length);
    decimal = decimal.replace(".", ",");
    return "R$ " + ajuste + decimal;
  }

  setNumber() {
    this.valor = Number(this.valor.replace("R$ ", "").replaceAll(".", "").replace(",", "."));
  }
}
